<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
              <li><a routerLink="/">Inicio</a></li>
              <li>Listado de Afiliados</li>
            </ul>
            <h2>Listado de Afiliados</h2>            
        </div>
    </div>
<app-loading *ngIf="!flagLoaded"
             class="m-5">
</app-loading><br>

<div class="profile-area pb-70">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Afiliados</h3>
            <a routerLink="/afiliado-alta"><i class="fas fa-plus"></i> Agregar Afiliado</a>
            <hr>
            <div class="search-bar">
                <mat-form-field appearance="outline">
                    <mat-label>Buscar Afiliado</mat-label>
                    <input matInput
                           [(ngModel)]="searchTerm"
                           (keyup.enter)="searchPersonas()"
                           placeholder="Nombre, apellido, DNI, email o teléfono.."
                           autocomplete="off">
                </mat-form-field>
                <button mat-raised-button
                        class="btn-buscar"
                        (click)="searchPersonas()">
                    <i class="fas fa-search"></i> Buscar
                </button>
                <button mat-raised-button
                        class="btn-limpiar"
                        (click)="clearSearch()">
                    <i class="fas fa-eraser"></i> Limpiar
                </button>
            </div>

            <div class="mat-elevation-z8">

                <table mat-table
                       [dataSource]="dataSource"
                       matSort>

                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Nombre </th>
                        <td mat-cell
                            *matCellDef="let element"> {{element.nombrePersona}} </td>
                    </ng-container>

                    <ng-container matColumnDef="apellido">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Apellido </th>
                        <td mat-cell
                            *matCellDef="let element"> {{element.apellidoPersona}} </td>
                    </ng-container>

                    <ng-container matColumnDef="identificacion">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Identificación </th>
                        <td mat-cell
                            *matCellDef="let element"> {{element.identificacion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="telefono">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Teléfono </th>
                        <td mat-cell
                            *matCellDef="let element"> {{element.telefono}} </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Email </th>
                        <td mat-cell
                            *matCellDef="let element"> {{element.email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="_id">
                        <th mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header> Acciones </th>
                        <td mat-cell
                            *matCellDef="let element"
                            class="acciones-cell">
                            <button style="margin-right: 5px;"
                                    (click)="element.signoSedes && verDetalle(element.signoSedes[0], element._id)"
                                    [disabled]="!element.signoSedes"
                                    type="button"
                                    title="Ver sede asignada"
                                    class="btn btn-primary"><i class="fas fa-home"></i></button>
                         
                             <button style="margin-right: 5px;"
                                    (click)="verDetalleGecros(element)"
                                    type="button"
                                    title="Ver datos usuario"
                                    class="btn btn-success"><i class="fas fa-eye"></i></button>
                          
                              <button  style="margin-right: 5px;" (click)="verPersona(element._id)"
                                    type="button"
                                    class="btn btn-warning"><i class="fas fa-edit"></i></button>
                                    
                            <button style="margin-right: 5px;" (click)="verUsuario(element._id)" type="button" title="Modificar datos usuario"
                              class="btn btn-warning"><i class="fas fa-user"></i>
                            </button>

                            <button type="button" style="margin-right: 2%;" title="Modificar contraseña" class="btn btn-danger"
                              (click)="this.openDialogModificarClave(element._id)">
                              <i class="fa fa-key" aria-hidden="true"></i>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row
                        *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns;"
                        class="example-element-row"></tr>
                </table>

            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100, 150, 200]"
                           showFirstLastButtons></mat-paginator>

        </div>
    </div>
</div>